import 'styles/heros/heroBanner.less';

import { ArrowIcon } from 'components/common/icons/ArrowIcon';
import { CustomerLogos } from 'components/generic/customers/CustomerLogos';
import React from 'react';

const HeroBanner = () => {
    return (
        <div className="w-100 flex heroBottomBanner relative tw-bg-[#000]">
            <div className="absolute w-100 h-100 flex backgroundFillers">
                <div className="w-50 tw-bg-primaryTeal" style={{ marginRight: 320 }}></div>
                <div className="w-50 tw-bg-[#000]"></div>
            </div>
            <div className="container z-1 flex">
                <div className="w-50 h-100 logoContainer xl:tw-bg-[#000] tw-bg-primaryTeal">
                    <CustomerLogos style={{ height: 178 }} />
                </div>
                <div className="w-50 h-100 relative statContainer">
                    <div
                        className="flex itemsCenter justifyCenter w-100 h-100"
                        style={{ color: '#fff' }}
                    >
                        <div className="tw-flex tw-items-center">
                            <p
                                className="number tw-text-[88px]"
                    
                            >
                                33<span style={{ color: '#1eafaa' }}>%</span>
                            </p>
                            <span style={{ marginLeft: 15, marginRight: 30 }}>
                                <ArrowIcon height={60} width={57} />
                            </span>
                        </div>
                        <p style={{ maxWidth: 390, margin: 0 }} className="tw-text-xl tw-text-neutral-dark-subdued">
                            Closed deals increase <br/>in the first 12 months
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;
